import React from 'react'
import Vendordash from '../../components/vendordashboard/Vendordash'


function Vendordashboard({renderPageContent}) {
    return (
        <>
                        <Vendordash renderPageContent={renderPageContent}/>
                       
                       
        </>
    )
}
export default Vendordashboard
